






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class InputError extends Vue {
  @Prop(Object) v: Types.VuelidateValidation;
  @Prop(Object) vMessages: Array<{[type: string]: string}>;

  $refs: {
    container: HTMLDivElement,
  }

  messagesByType: { [type: string]: string } = {
    required: this.$t('inputError.messagesByType.required'),
    url: this.$t('inputError.messagesByType.url'),
    unique: this.$t('inputError.messagesByType.unique'),
    email: this.$t('inputError.messagesByType.email'),
    password: this.$t('inputError.messagesByType.password'),
    noDuplicates: this.$t('inputError.messagesByType.noDuplicates'),
    notCurrentEmail: this.$t('inputError.messagesByType.notCurrentEmail'),
    samePassword: this.$t('inputError.messagesByType.samePassword'),
    minLength: this.$t('inputError.messagesByType.minLength'),
    minLength3: this.$t('inputError.messagesByType.minLength3'),
    passwordStrength: this.$t('inputError.messagesByType.passwordStrength'),
  };

  duration: number = 200;
  invalidParams: string[] = [];
  repeatableInvalidParams: { index: number, param: string }[] = [];

  /*
    Everytime the user submits a form, this watcher is triggered (no matter the
    form contains validation errors or not). This method allows the container to
    reset its style everytime a form is submitted, to avoid empty template datas
    before the validation plugins finishes its work.
  */
  @Watch('v.$error')
  function (newValue: boolean) {
    if (newValue) {
      this.updateInvalidParams();
      setTimeout(() => {
        this.$refs.container.style.opacity = '1';
        this.$refs.container.style.height = `${this.$refs.container.scrollHeight}px`;
      }, 0);
    } else {
      this.$refs.container.style.opacity = '0';
      this.$refs.container.style.height = '0';
      setTimeout(() => {
        this.updateInvalidParams();
      }, this.duration);
    }
  }

  /* This method will print the error associated by the validation param ID given */
  getMessage (param: number) {
    // if a param is specified, take it, even if it is falsy
    if (this.vMessages && param in this.vMessages) return this.vMessages[param];
    return this.messagesByType[param] || param;
  }

  /*
    This method iterates the validation repeated errors to
    create an array in template so we can print every errors
  */
  updateInvalidParams () {
    this.invalidParams = this.getInvalidParams(this.v);
    const repeatableParams = [];
    if (this.v.$each) {
      // NOTE: $iter is not an array but an object with index like properties
      const iter = this.v.$each.$iter;
      // Build a flat list of invalid params with initial index (+1 to start at 1)
      for (const indexLike in iter) {
        for (const param of this.getInvalidParams(iter[indexLike])) {
          repeatableParams.push({ index: Number(indexLike) + 1, param });
        }
      }
    }
    this.repeatableInvalidParams = repeatableParams;
  }

  /*
    This method facilitates the process of this.updateInvalidParams to get
    invalidated params of the validation
  */
  getInvalidParams (validator: any) {
    const result = [];
    for (const errorType in validator.$params) {
      if (validator[errorType] === false) result.push(errorType);
    }
    return result;
  }
};
